(function () {
  var DAY = 86400000;
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    var now = Date.now();
    var timers = document.querySelectorAll('[data-dm-countdown]');
    timers.forEach(function (el) {
      var endSec = parseInt(el.getAttribute('data-ends'), 10);
      if (!endSec) return;
      var end = endSec * 1000;
      var diff = end - now;
      var root = el.closest('[data-dm-drop]') || el;
      if (diff <= 0) {
        root.classList.add('is-retired');
        el.classList.add('is-retired');
        if (el.hasAttribute('data-dm-retire-page')) document.body.classList.add('dm-retired');
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var hEl = el.querySelector('[data-unit="h"]');
      var mEl = el.querySelector('[data-unit="m"]');
      var sEl = el.querySelector('[data-unit="s"]');
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
      var bar = el.querySelector('[data-dm-progress]');
      if (bar) bar.style.width = Math.max(0, Math.min(100, (diff / DAY) * 100)) + '%';
      root.classList.toggle('is-final-hour', diff < 3600000);
    });
    document.querySelectorAll('[data-dm-ends-text]').forEach(function (el) {
      var endSec = parseInt(el.getAttribute('data-dm-ends-text'), 10);
      if (!endSec || el.dataset.done) return;
      try {
        el.textContent = new Date(endSec * 1000).toLocaleString(undefined, { weekday: 'short', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
        el.dataset.done = '1';
      } catch (e) {}
    });
  }
  function start() { tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
